import React from 'react'

import "./home.css";
import Typewriter from "typewriter-effect";

import im from "./home_anime.f372ef86.gif";
import {Link} from 'react-router-dom';
export default function Home() {
	return (
		<div className="di">
			
<h1 className="text-center font-bold hh">

<Typewriter
  

options={{
    delay: 75,
    autoStart: true,
    
  }}


       onInit={(typewriter)=> {

       typewriter
        
       .typeString("welcome to my portfolio :) .")
         

       

       .start();
       }}
       /> 



	</h1>	



<div class="text-box d-flex justify-content-center mt-20">

<Link to="/about" className="btn  btn-animate but">
     Know more about me</Link>
</div>




<div className="text-box1 d-flex justify-content-center ">
<Link to="/contact" className="btn  btn-animate but1">
     Connect with me</Link>
</div>
<div className="imd">
<img src={im}/>
</div>
		</div>
		)
}